import buildScreenHeaderItems from '@/components/buildScreenHeaderItems'
import closeButton from '@/components/closeButton'
import useWebBackButton from '@/lib/hooks/useWebBackButton'
import LoginViaIdentity from '@/modules/session/LoginViaIdentity'
import { Stack, useRouter } from 'expo-router'
import { Platform } from 'react-native'

export default function LoginViaIdentityPage() {
  const router = useRouter()
  const headerLeftItems = useWebBackButton('/login')

  return (
    <>
      <Stack.Screen
        options={{
          ...buildScreenHeaderItems({
            left: headerLeftItems,
            right: Platform.OS !== 'web' ? [closeButton({ onPress: () => router.back() })] : undefined,
          }),
        }}
      />
      <LoginViaIdentity />
    </>
  )
}
